export default __webpack_public_path__ + "static/media/006-parrot.a155b341.png";